import { store } from 'store';

function closeNotifs() {
  store.dispatch({
    type: 'UPDATE_APP_STATE',
    payload: {
      showNotifications: false
    }
  });
}

export default closeNotifs;
